export type NotificationEventType =
    | 'TIMESHEET_SUBMITTED'
    | 'TIMESHEET_VALIDATED'
    | 'CRA_REJECTED'
    | 'CRA_COMMENT'
    | 'TICKET_OVERDUE'
    | 'DEFAULT';

export type NotificationStatus = 'SENT' | 'FAILED' | 'PENDING';
export type RecipientType = 'USER' | 'CANDIDATE' | 'COMPANY' | 'RESOURCE';

export interface Notification {
    id: string | number;
    title: string;
    body: string;
    topic?: string;
    status?: NotificationStatus;
    data?: { [key: string]: string };
    recipientId?: number;
    recipientType?: RecipientType;
    createdAt: string | Date;
    sentAt?: string | Date;
    errorMessage?: string;
    eventType?: NotificationEventType;
    read: boolean;
    // Legacy support
    icon?: string;
    image?: string;
    description?: string;
    time?: string;
    link?: string;
    useRouter?: boolean;
}

export interface NotificationConfig {
    icon: string;
    primaryColor: string;
    backgroundColor: string;
    actionLabel?: string;
    actionRoute?: string;
}

export const NOTIFICATION_CONFIG: Record<NotificationEventType, NotificationConfig> = {
    TIMESHEET_SUBMITTED: {
        icon: 'heroicons_outline:document-check',
        primaryColor: 'text-blue-600',
        backgroundColor: 'bg-blue-50',
        actionLabel: 'Review',
        actionRoute: '/admin/timesheets',
    },
    TIMESHEET_VALIDATED: {
        icon: 'heroicons_outline:check-circle',
        primaryColor: 'text-green-600',
        backgroundColor: 'bg-green-50',
        actionLabel: 'View',
        actionRoute: '/timesheets',
    },
    CRA_REJECTED: {
        icon: 'heroicons_outline:exclamation-circle',
        primaryColor: 'text-red-600',
        backgroundColor: 'bg-red-50',
        actionLabel: 'Revise',
        actionRoute: '/timesheets',
    },
    CRA_COMMENT: {
        icon: 'heroicons_outline:chat-bubble-left',
        primaryColor: 'text-amber-600',
        backgroundColor: 'bg-amber-50',
        actionLabel: 'Read',
        actionRoute: '/timesheets',
    },
    TICKET_OVERDUE: {
        icon: 'heroicons_outline:exclamation-triangle',
        primaryColor: 'text-red-600',
        backgroundColor: 'bg-amber-50',
    },
    DEFAULT: {
        icon: 'heroicons_outline:bell',
        primaryColor: 'text-gray-600',
        backgroundColor: 'bg-gray-50',
    },
};
